import React from 'react';
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';
import { useRadioGroup } from '@mui/material/RadioGroup';
import { Styled } from './fancy-radio.styled';

type FancyRadioProps = {
    icon?: React.ReactNode;
    value?: unknown;
    label: React.ReactNode;
};

const CheckedIcon: React.FC = (): JSX.Element => {
    return (
        <Styled.RadioIcon
            children={
                <Styled.RadioCheckedIcon
                    children={<i className="fa-solid fa-check"></i>}
                />
            }
        />
    );
};

const FancyRadio: React.FC<FancyRadioProps> = ({ icon, label, ...rest }) => {
    const radioGroup = useRadioGroup();
    const checked = radioGroup
        ? String(radioGroup.value) === String(rest.value)
        : false;

    return (
        <Styled.Radio className={'fancy-radio' + (checked ? ' active' : '')}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                <Styled.Icon>{icon}</Styled.Icon>
                <Typography>{label}</Typography>
            </Box>
            <FormControlLabel
                label=""
                control={
                    <Radio
                        disableRipple
                        checkedIcon={<CheckedIcon />}
                        icon={<Styled.RadioIcon />}
                    />
                }
                {...rest}
            />
        </Styled.Radio>
    );
};

export { FancyRadio };
export type { FancyRadioProps };
